import {map} from 'nanostores'

export const $mouse = map({
    x: window.innerWidth * 0.5,
    y: window.innerHeight * 0.5,
    smoothX: window.innerWidth * 0.5,
    smoothY: window.innerHeight * 0.5,
    lerp: 0.2,
})